import { AxiosResponse } from 'axios';
import API from '../Common/axios';
import { TeamCatastropheStatisticsRow } from './types';

export const getTeamCatastropheStatistics = (params: {
  filter_team?: string;
  filter_operational_manager?: string;
  filter_residence_groups?: (number | undefined)[];
  filter_regions?: (number | undefined)[];
  date?: string;
  is_active?: boolean;
  show_difficult?: boolean;
  show_without_catastrophe?: boolean;
  show_inactive?: boolean;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  page?: number;
}): Promise<AxiosResponse> => {
  return API.get<{ data: TeamCatastropheStatisticsRow[] }>('/v1/statistics/team_catastrophe_work_shifts', {
    params,
  });
};

export const getEmployeeTurnoverXlsx = async (params: {
  team_ids: number[];
  type: 'employment_start' | 'employment_end';
  start_date?: string;
  end_date?: string;
  show_men: boolean;
  show_women: boolean;
  only_employed: boolean;
  min_days?: number;
  max_days?: number;
}): Promise<AxiosResponse> => {
  return await API.get<Buffer>('/v1/employees_statistics/turnover', {
    params,
    responseType: 'arraybuffer',
  });
};

export const getResidenceWorkedHours = (params: { start_date: string; end_date: string }): Promise<AxiosResponse> => {
  return API.get('/v1/residence_statistics/worked_hours', {
    params,
  });
};
